import { IconAlertCircle, IconCheckCircle } from '@/components'
import { SYSTEM_DIAGNOSTIC_METRICS, SystemDiagnosticMetricEnum, SystemDiagnosticMetricStatusEnum } from '@/enums'
import { SystemDiagnosticMetricDataType } from '@/types'

export class SystemDiagnosticMetric {
    key: SystemDiagnosticMetricEnum

    title: string

    description?: string

    value?: number

    valueFormatted?: string | number

    status: SystemDiagnosticMetricStatusEnum

    constructor(data: SystemDiagnosticMetricDataType) {
        this.key = data.key
        this.value = data.value
        const metric = SYSTEM_DIAGNOSTIC_METRICS
            .find(item => item.key === data.key)
        this.title = metric?.title || data.key
        this.description = metric?.description
        this.valueFormatted = metric?.format ? metric.format(data.value) : data.value
        this.status = metric?.status ? metric.status(data.value) : SystemDiagnosticMetricStatusEnum.ERRORED
    }

    get isNormal() {
        return this.status === SystemDiagnosticMetricStatusEnum.NORMAL
    }

    get isErrored() {
        return this.status === SystemDiagnosticMetricStatusEnum.ERRORED
    }

    get statusIcon() {
        return this.isNormal
            ? SystemDiagnosticMetric.normalIcon
            : SystemDiagnosticMetric.erroredIcon
    }

    static normalIcon = <IconCheckCircle
        size="sm"
        className="stroke-success-600 shrink-0"
    />

    static erroredIcon = <IconAlertCircle
        size="sm"
        className="stroke-error-600 shrink-0"
    />
}
